
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AppTopWarning extends Vue {
  @Prop({ required: true }) message!: string;
}
